export default __webpack_public_path__ + "static/media/33.70085935.gif";